export interface InputState {
  value: string;
}

export enum InputType {
  Text = `text`,
  Password = `password`,
  Number = `number`,
  TextArea = `textarea`,
}

export enum InputSize {
  Small = `small`,
  Medium = `medium`,
  Large = `large`,
}

export enum InputTheme {
  Default = `default`,
  Chrome = `chrome`,
}

export enum Necessary {
  Default = ``,
  Optional = `optional`,
  Required = `required`,
}

export enum ValidationStatus {
  Default = ``,
  Valid = `valid`,
  Invalid = `invalid`,
}

export type InputChangeEvent = CustomEvent<{
  value: string;
}>;

export enum TextAlign {
  Start = `start`,
  Center = `center`,
  End = `end`,
}

export enum AutocompleteType {
  CurrentPassword = `current-password`,
  Email = `email`,
  InviteUsersAutocompleteOff = `invite-users-autocomplete-off`,
  Off = `off`,
}
